/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
  oauth: {
    domain: "progali-prod.auth.sa-east-1.amazoncognito.com",
    scope: [
      // 'phone',
      "email",
      "profile",
      "openid",
      // 'aws.cognito.signin.user.admin'
    ],
    redirectSignIn: `${import.meta.env.VITE_URL_BASE}/acessoFederado?`,
    redirectSignOut: `${import.meta.env.VITE_URL_BASE}`,
    responseType: "token", // or 'token', note that REFRESH token will only be generated when the responseType is code
  },
  aws_project_region: "sa-east-1",
  aws_cognito_region: "sa-east-1",
  aws_user_pools_id: "sa-east-1_0vzXvlDkm",
  aws_user_pools_web_client_id: "4kcuatqgm8htj9r2spjh5aqqe1",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: [],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS",
    ],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export default awsmobile;
